<header class="header">
  <div class="header-content">
    <div class="logo-section">
      <img src="assets/images/logo/logo.png" alt="Logo" class="velocity-logo" />
      <div class="logo-text-section">
        <span class="logo-text">Risk Assessment CoPilot</span>
        <br>
        <div class="logo-subtext">
          powered by Bluepond.AI
        </div>
      </div>
    </div>



    <div class="right-section">
           <lib-support
          [isOpen]="isPanelOpen"
          (closePanel)="isPanelOpen = false"
          [appId]="appId"
          [panelTitle]="'RA Support'"
        ></lib-support>
      <div class="user-section">
        <a class="dropdown-link" data-bs-toggle="dropdown">
           <span class="user-initials">{{firstName.charAt(0)}}{{lastName.charAt(0)}}</span>
          <span class="user-name">{{userName}}</span>
          <img src="assets/images/icons/dropdown-icon.svg" alt="Dropdown Icon" class="dropdown-icon" />
        </a>
      
        <div class="dropdown">
          <ul class="dropdown-menu dropdown-menu-end">
            <li class="user-info">
              <span class="user-email">{{ email }}</span>
            </li>
            
            <li>
              <a>
                <button class="logout-btn" (click)="logout()" title="Logout">
                  <img src="assets/images/icons/logout-icon.svg" alt="Logout Icon" class="logout-icon" />
                  <span>Logout</span>
                </button>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</header>
